export { DiFormService } from "./service/di-form-service/di-form.service";

export { DiBaseComponent } from "./base/di.base.component";
export { DiBaseFormComponent } from "./base/di.base-form.component";

export { DiBaseDTO } from "./base/di.base.dto";
export { DiBaseSearchDTO } from "./base/di.base-search.dto";